export class ColorizedIcon {
  icon: string;
  color: string;
}

export class ColorizedIconHelper {
  public static toHtml(colorizedIcons: ColorizedIcon[]) {
    let html = '';
    if (colorizedIcons.length > 0) {
      html += '<div class="h-100 d-flex align-items-center justify-content-center gap-1">';
      for (const colorizedIcon of colorizedIcons) {
        html += `<span class="${colorizedIcon.icon}" style="color: ${colorizedIcon.color}"></span>`;
      }
      html += '</div>';
    }
    return html;
  }
}
